// extracted by mini-css-extract-plugin
module.exports = {"notFound":"styles_notFound__11TRF","text":"styles_text__2ISeG"};